// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";
import { Button, Link, ButtonComposed, modal } from "@lifepay/rc-ui-toolkit";
import { Lock } from "@lifepay/redux-subsystem-access";

// ABSOLUTE PATH IMPORTS
import { LOCK_KEYS } from "accessConfig";
import CardPinCounterReset from "data-containers/CardPinCounterReset";

// RELATIVE PATH IMPORTS
// importing default component styles
import styles from "./CardResetPinCountControl.m.scss";

@themr("@lifepay/CardResetPinCountControl", styles)
export default class CardResetPinCountControl extends Component {
  // declaring props passed to the component
  static propTypes = {
    theme: PropTypes.object,
    oldPhone: PropTypes.string,
    cardId: PropTypes.string,
    onSuccess: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      phone: props.oldPhone || "",
      loading: false,
      error: null,
      submitButtonState: "normal",
    };
  }

  componentWillReceiveProps(newProps) {
    if (this.props.cardId !== newProps.cardId) {
      this.setState({ phone: newProps.oldPhone });
    }
  }

  activateCard = ({ activateCard }) => {};

  blockCard = ({ activateCard }) => {};

  render() {
    const { theme, cardId, onSuccess } = this.props;
    const { phone, loading, error, submitButtonState } = this.state;
    return (
      <modal.ModalController>
        {({ isOpen, close, open }) => {
          return (
            <React.Fragment>
              <Lock
                lockId={LOCK_KEYS.CARD_PIN_COUNTER_RESET}
                type={"lock"}
                theme={{
                  wrapper: theme.button,
                }}
              >
                <Button type={"alt"} size={"small"} onClick={open}>
                  {"Сбросить счетчик пинкода"}
                </Button>
              </Lock>
              <modal.ModalBox
                isOpen={isOpen}
                close={() => {
                  if (!loading) {
                    close();
                  }
                }}
                theme={{
                  inner: theme.modal,
                }}
              >
                <CardPinCounterReset cardId={cardId} contacts={{ phone }}>
                  {({ resetPinCounter }) => {
                    const submit = (
                      <div className={classnames(theme.submit)}>
                        <ButtonComposed
                          state={submitButtonState}
                          disabled={submitButtonState !== "normal"}
                          type={"main"}
                          size={"small"}
                          text={"Подтвердить"}
                          theme={{
                            wrapper: theme.button,
                          }}
                          onClick={() => {
                            this.setState({
                              loading: true,
                              submitButtonState: "loading",
                            });
                            resetPinCounter({
                              update: (proxy, response) => {
                                this.setState({
                                  loading: false,
                                  submitButtonState: "normal",
                                });
                                onSuccess();
                                close();
                              },
                            }).catch((e) => {
                              this.setState({
                                loading: false,
                                error: e,
                                submitButtonState: "error",
                              });
                            });
                          }}
                        >
                          {"Подтвердить"}
                        </ButtonComposed>
                        <Button
                          type={loading ? "disabled" : "alt"}
                          size={"small"}
                          disabled={loading}
                          theme={{
                            wrapper: theme.button,
                          }}
                          error
                          onClick={() => {
                            close();
                          }}
                        >
                          {"Отмена"}
                        </Button>
                      </div>
                    );

                    return (
                      <div className={classnames(theme["modal-content"])}>
                        <div>
                          <div
                            className={classnames(theme.summary)}
                          >{`Сбросить счетчик неверных попыток ввода пинкода`}</div>
                          {error ? (
                            <React.Fragment>
                              <div className={classnames(theme.summary)}>
                                {error.message}
                              </div>
                              <div className={classnames(theme.summary)}>
                                <Link
                                  type={"negative"}
                                  withRouter={false}
                                  // theme={{
                                  //   wrapper: theme.button,
                                  // }}
                                  onClick={() => {
                                    this.setState({
                                      error: null,
                                      submitButtonState: "normal",
                                    });
                                  }}
                                >
                                  {"Очистить ошибку"}
                                </Link>
                              </div>
                            </React.Fragment>
                          ) : null}
                        </div>
                        {submit}
                      </div>
                    );
                  }}
                </CardPinCounterReset>
              </modal.ModalBox>
            </React.Fragment>
          );
        }}
      </modal.ModalController>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/emission/cards/controls/CardResetPinCountControl/CardResetPinCountControl.js